'use client';

import { MutableRefObject, Suspense, useEffect, useState } from 'react';
import Spline from '@splinetool/react-spline';
import { Application } from '@splinetool/runtime';

const CANVAS_ID = 'workWithUsCanvas';
const CANVAS_URL = 'https://prod.spline.design/psazuipseYnm8bBi/scene.splinecode';

export const SplineCanvas = ({ spline }: { spline: MutableRefObject<Application | null> }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  const handleOnLoad = (loadedSpline: Application) => {
    spline.current = loadedSpline;
  };

  return (
    <>
      <Suspense>
        {!isLoading && (
          <Spline
            className='block z-10 bg-transparent pointer-events-none scale-[1.1] md:scale-[1.05]'
            onLoad={handleOnLoad}
            id={CANVAS_ID}
            scene={CANVAS_URL}
            renderOnDemand
          />
        )}
      </Suspense>
      {/* Loader is disabled here because this section is below the fold */}
      {/* <Loader isReady={!isLoading} /> */}
    </>
  );
};
